/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_SuccessInputs */

const vi_carrier_return_decision_success = /** @type {(inputs: Carrier_Return_Decision_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi phản hồi cho Viettel Post`)
};

/**

* @param {Carrier_Return_Decision_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_success = /** @type {((inputs?: Carrier_Return_Decision_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_success(inputs)
});